import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {AnalyticsActions} from "../../../Redux/Actions/analytics.actions";
import {ActionsService} from "../../../Redux/Actions/actions.service";

@Component({
  selector: 'edsng-confirm-import-dlg',
  templateUrl: './confirm-import-dlg.component.html',
  styleUrls: ['./confirm-import-dlg.component.css']
})
export class ConfirmImportDlgComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ConfirmImportDlgComponent>, private act: ActionsService) {}

  ngOnInit() {
  }

  importFile() {
    this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
      'import_user_file',
      'project',
      {details: 'file name=' + this.data.file, module: "home"}));
    window.open(this.data.param.base + this.data.param.app + "?msg=" + encodeURIComponent(this.data.param.msg));
    this.closeDlg('Import');
  }

  closeDlg(message: string) {
    this.dialogRef.close(message);
  }
}
